import { call, put, takeEvery } from "redux-saga/effects";
import { ConfigActions, GET_CMS_BANNER } from "@redux/reducer";
import { CMSPayloadType, CMSBannerResponse } from "@type/index";
import request from "@util/net/request";
import axios, { AxiosResponse } from "axios";

export function* getBannerSaga(action: { payload: CMSPayloadType }) {
  const payload: CMSPayloadType = action.payload;
  try {
    yield put(ConfigActions.loadingCmsBanner(true));
    const res: AxiosResponse<CMSBannerResponse> = yield call(
      request.get,
      "/cms",
      {
        params: {
          device: payload.device,
          path: payload.path
        }
      }
    );
    if (
      res.data.status === "ok" &&
      res.data.result.body &&
      res.data.result.body.length > 0
    ) {
      if (
        res.data.result.body[0].content &&
        res.data.result.body[0].content.length > 0 &&
        res.data.result.body[0].content[0].children
      ) {
        yield put(
          ConfigActions.setCmsBanner({
            children: res.data.result.body[0].content[0].children,
            url: res.data.result.body[0].content[0].url,
            target: res.data.result.body[0].content[0].target,
            loading: false
          })
        );
      } else if (res.data.result.body[0].children) {
        yield put(
          ConfigActions.setCmsBanner({
            children: res.data.result.body[0].children,
            url: res.data.result.body[0].url,
            target: res.data.result.body[0].target,
            loading: false
          })
        );
      } else {
        yield put(
          ConfigActions.setCmsBanner({
            children: [],
            url: "",
            target: "",
            loading: false
          })
        );
      }
    } else {
      yield put(
        ConfigActions.setCmsBanner({
          children: [],
          url: "",
          target: "",
          loading: false
        })
      );
    }
  } catch (error) {
    if (!axios.isCancel(error)) {
      yield put(
        ConfigActions.setCmsBanner({
          children: [],
          url: "",
          target: "",
          loading: false
        })
      );
    }
  }
}

export function* watchLoadBannerSaga() {
  yield takeEvery<any>(GET_CMS_BANNER, getBannerSaga);
}
